<template>
  <div class="container-fluid main_content">
    <location-line :step1="'이력관리'" :step2="'세부 이력관리'"/>
    <car-info-box/>
    <div class="tabs">
      <nav class="nav justify-content-start">
        <router-link tag="div" class="nav-link"
                     :to="{name:'HistoryDrive', params:{seq:this.$route.params.seq}, query:this.$route.query, hash: $route.hash}"
                     :class="this.$route.name === 'HistoryDrive' ? 'router-link-active':''">
          운행
          <span class="bottom_border"></span>
        </router-link>
        <router-link tag="div" class="nav-link"
                     :to="{name:'HistoryManage', params:{seq:this.$route.params.seq}, query:this.$route.query, hash: $route.hash}">
          관리
          <span class="bottom_border"></span>
        </router-link>
        <router-link tag="div" class="nav-link"
                     :to="{name:'HistoryIssue', params:{seq:this.$route.params.seq}, query:this.$route.query, hash: $route.hash}">
          사고
          <span class="bottom_border"></span>
        </router-link>
      </nav>
    </div>
    <div class="sub_content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import CarInfoBox from '@/components/CarInfoBox'
import LocationLine from '@/components/LocationLine'

export default {
  name: 'HistoryView',
  components: {
    LocationLine,
    CarInfoBox
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  padding: 30px 0px 15px 15px;
  font-size: 12px;
  font-weight: normal;

  .nav {
    border-bottom: 1px solid #F0F0F0;
  }

  .nav-link {
    color: #979799;
    position: relative;
    padding: 0px;
    cursor: pointer;
    height: 30px;
    margin: 0px 20px 0px 0px;

    &.router-link-active {
      color: #007DEF;

      .bottom_border {
        display: inline-block;
        position: absolute;
        left: 0px;
        bottom: 0px;
        height: 5px;
        width: 100%;
        background: #007DEF;
        border-radius: 10px 10px 0px 0px;
      }
    }

  }
}

.sub_content {
  padding: 15px 0px 15px 15px;
}
</style>
